const IPHONE_SE_WIDTH = 568;

export const isSmallViewPortWidth = () => window.outerWidth <= IPHONE_SE_WIDTH;



// WEBPACK FOOTER //
// ./src/helpers/display_util.js